<div class="orderTotal" [class.withLines]="groups?.length">
  @if (groups?.length) {
    <div class="orderTotalGroups">
      @for (group of groups; track group.key) {
        <div class="orderTotalGroup">
          @if (group.title) {
            <span class="orderTotalEyebrow">{{ group.title }}</span>
          }
          @for (line of group.lines; track line.key) {
            <div class="orderTotalLine" [class.discount]="line.discount">
              @if (line.dot) {
                <span class="orderTotalLineDot" [style.background]="line.color || null" aria-hidden="true"></span>
              }
              <span class="orderTotalLineLabel">
                {{ line.label }}@if (line.detail) {<span class="orderTotalLineDetail"> · {{ line.detail }}</span>}@if (line.quantity > 0) {<span class="orderTotalLineQuantity"> ×{{ line.quantity }}</span>}
              </span>
              <span class="orderTotalLineAmount">{{ line.discount ? '-' : '' }}{{ line.amount | number:'1.2-2' }}€</span>
            </div>
          }
        </div>
      }
    </div>
  }
  <div class="orderTotalSummary">
    <div class="orderTotalLabel">
      <span class="orderTotalEyebrow">{{ 'GENERIC.TOTAL' | translate }}</span>
      @if (amount > 0 && vat > 0) {
        <span class="orderTotalVat">{{ 'GENERIC.VAT' | translate }} {{ vat | number:'1.2-2' }}€</span>
      }
    </div>
    <div class="orderTotalAmount">
      @if (amount > 0 || isDiscounted) {
        @if (isDiscounted) {
          <span class="orderTotalOriginal">{{ originalAmount | number:'1.2-2' }}€</span>
        }
        <span class="orderTotalValue">{{ amount | number:'1.2-2' }}€</span>
        <span class="orderTotalTax">{{ 'GENERIC.INCL_VAT' | translate }}</span>
      } @else {
        <span class="orderTotalValue empty">-</span>
      }
    </div>
  </div>
  @if (actionLabel) {
    <div class="orderTotalActions">
      <button type="button" class="orderTotalAction" (click)="action.emit()">
        <span>{{ actionLabel }}</span>
        <span class="orderTotalActionIcon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none" />
          </svg>
        </span>
      </button>
    </div>
  }
</div>
